module.exports = __webpack_public_path__ + "static/job-training-body-1-697810d9d1f6fabf1cb25c370a36df00.png";